import type { ReactNode } from 'react';
import { Forbidden } from '@/ui/Forbidden';
import type { Permission } from './permissions';
import { useCan } from './session';

export function RequirePermission({
  permission,
  children,
}: {
  permission: Permission;
  children: ReactNode;
}) {
  const can = useCan();
  return can(permission) ? children : <Forbidden />;
}
